/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowUp: {
  name: 'arrow_up';
  data: string;
} = {
  name: 'arrow_up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M4.72 9.97a.75.75 0 1 0 1.06 1.06l5.47-5.47v14.69a.75.75 0 0 0 1.5 0V5.56l5.47 5.47a.75.75 0 1 0 1.06-1.06l-6.75-6.75a.748.748 0 0 0-1.06 0L4.72 9.97Z" fill="currentColor"/></svg>`
};
